// src/store/index.ts

import { combineReducers } from 'redux';
import { reducer } from 'redux-oidc';
import { intentReducer } from './intentReducer';
import { entityReducer } from './entityReducer';
import { flowReducer } from './flowReducer';
import { botReducer } from './botReducer';
import { statisticReducer } from './statisticReducer';
import loadingReducer from './loadingReducer';
import { dialogTranscriptionReducer } from './dialogTranscription';
import { AppReducer } from './appReducer';
import { monitoringGraphReducer } from './monitoringGraphReducer';
import { analyticsReducer } from './analyticsReducer';

export const rootReducer = combineReducers({
  intent: intentReducer,
  entity: entityReducer,
  flow: flowReducer,
  loading: loadingReducer,
  transcription: dialogTranscriptionReducer,
  bot: botReducer,
  oidc: reducer,
  statistic: statisticReducer,
  monitoringGraph: monitoringGraphReducer,
  analytics: analyticsReducer,
  app: AppReducer
});
